import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: theme.spacing(1),
    width: 220,
    [theme.breakpoints.down('xs')]: {
      width: '90vw',
    },
  },
  input: {
    margin: '32px 0 38px',
  },
}));
